import CloseIcon from "@mui/icons-material/Close";
import {
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  ListItemText,
  MenuItem,
  Select,
  Stack,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import React, { forwardRef, useEffect, useImperativeHandle } from "react";
// import { CategoryValidation } from "../../utils/Validation";
import GlobalButton from "../CustomButton";
import Label from "../Label";
import TextInput from "../TextInputs";
import { useBranches } from "../../hooks/branch";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
  "& .MuiPaper-root": {
    width: "500px",
    padding: theme.spacing(3),
    paddingBottom: theme.spacing(1),
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(1),
      margin: 12,
    },
  },
  "& .MuiDialogContent-root": {
    padding: "0 0 10px 0",
  },
}));

let paramsData = {};

const AddEditNewCategory = forwardRef((props, ref) => {
  const {
    open,
    setOpen,
    inputValues,
    handleClose,
    inputError,
    setInputValues,
    handleChageInputs,
    selectedBranches,
    setSelectedBranches,
    handleAddEditNewCategory,
  } = props;

  useImperativeHandle(ref, () => ({
    isVisible(params) {
      setOpen(true);
      paramsData = params;
      if (params.type === "edit") {
        setInputValues({
          name: params.data.name,
          description: params.data.description,
        });
      }
    },
  }));

  const { allBranches, fetchBranches } = useBranches();

  useEffect(() => {
    fetchBranches();
  }, []);

  return (
    <BootstrapDialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={open}
      scroll="body"
    >
      <Stack direction={"row"} justifyContent={"space-between"}>
        <DialogTitle sx={{ m: 0, p: 0 }} id="customized-dialog-title">
          {paramsData.type === "add" ? "Add Category" : "Edit Category"}
        </DialogTitle>
        <IconButton onClick={handleClose}>
          <CloseIcon />
        </IconButton>
      </Stack>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Label
              required
              labelText="Category name"
              htmlFor={"catrgory-name"}
            />
            <TextInput
              required
              inputError={inputError.name}
              helperText={inputError.name ? "Category name is required" : null}
              id={"catrgory-name"}
              placeholder={"Enter name"}
              name={"name"}
              value={inputValues.name}
              onChange={handleChageInputs}
            />
          </Grid>
          <Grid item xs={12}>
            <Label labelText="Select Branches" />
            <Select
              multiple
              fullWidth
              value={selectedBranches} // This should only contain _id values
              onChange={(e) => setSelectedBranches(e.target.value)}
              renderValue={(selected) =>
                selected
                  .map(
                    (id) =>
                      allBranches.find((b) => b._id === id)?.displayName ||
                      "Unknown"
                  )
                  .join(", ")
              }
            >
              {allBranches.map((branch) => (
                <MenuItem key={branch._id} value={branch._id}>
                  <Checkbox checked={selectedBranches.includes(branch._id)} />
                  <ListItemText primary={branch.displayName} />
                </MenuItem>
              ))}
            </Select>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <GlobalButton
          variant={"outlined"}
          btnText={"Cancel"}
          styleProps={{ width: 100, height: 40 }}
          handleClickBtn={handleClose}
        />
        <GlobalButton
          variant={"contained"}
          btnText={"Save"}
          styleProps={{ width: 100, height: 40 }}
          handleClickBtn={() => handleAddEditNewCategory(paramsData)}
        />
      </DialogActions>
    </BootstrapDialog>
  );
});

export default AddEditNewCategory;
